import { PlotlyModule } from "angular-plotly.js";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { RtGraphicsComponent } from "../../components/rt-graphics/rt-graphics.component";

@NgModule({
  declarations: [RtGraphicsComponent],
  imports: [
    CommonModule,
    PlotlyModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [RtGraphicsComponent],
})
export class RealTimeModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
